import { ChevronDownIcon, CloseIcon, HamburgerIcon, RepeatIcon } from "@chakra-ui/icons";
import packageJson from "../../package.json";
import {
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Icon,
  IconButton,
  Input,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
  Portal,
  Slide,
  Stack,
  Text,
  Tooltip,
  VStack,
  useColorModeValue as mode,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { BiLogInCircle, BiUserCheck } from "react-icons/bi";
import { TfiControlBackward } from "react-icons/tfi";
import { IoGameController } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { Link as ReactLink, useNavigate } from "react-router-dom";
import { logoutUser } from "../redux/actions/userActions";
import ColorModeToggle from "./ColorModeToggle";
import "./header.css";
import NavLink from "./NavLink";

const Links = [
  //{ name: "Dashboard", route: "/dashboard" },
  { name: "Jobs List", route: "/jobs" },
  { name: "Job Search", route: "/job-search" },
  { name: "Totals", route: "/totals" },
  { name: "Messages", route: "/messages" },
  //{ name: "Setup", route: "/setup" },
  // { name: "Services", route: "/services" },
];

const Header = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.user);
  const { jobsInProgress, jobsPaused, lastViewedJobNum } = useSelector((state) => state.job);
  // Get current pathname to avoid showing button when already viewing the job
  const currentPath = window.location.pathname;
  const toast = useToast();
  const [showBanner, setShowBanner] = useState(userInfo ? !userInfo.active : false);
  const [jobNoValue, setJobNoValue] = useState("");

  const gray700400 = mode("gray.700", "gray.400");
  const menuGroupBg = mode("yellow.100", "yellow.900");

  useEffect(() => {
    if (userInfo && !userInfo.active) {
      setShowBanner(true);
    }
  }, [dispatch, showBanner, userInfo, jobsInProgress, jobsPaused]);

  const logoutHandler = () => {
    dispatch(logoutUser());
    toast({
      description: "You have been logged our",
      status: "success",
      isClosable: true,
    });
  };

  const closeMenu = () => {
    //console.log("closeMenu called");
    if (isOpen) {
      onClose();
    }
  };

  return (
    <Box className='sticky-header' bg={mode("cyan.300", "gray.900")} px='4'>
      <Flex h='16' alignItems='centre' justifyContent='space-between'>
        <Flex display={{ base: "flex", md: "none" }} alignItems='center'>
          <IconButton
            bg='parent'
            size='md'
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            onClick={isOpen ? onClose : onOpen}
          />
        </Flex>
        <HStack spacing='8' alignItems='center'>
          <Button
            as={ReactLink}
            cursor='pointer'
            alignItems='cen ter'
            to='/dashboard'
            variant='ghost'
            py='1'
            rounded='md'
            onClick={closeMenu}
          >
            <Box alignItems='center' display='flex' mr='-4'>
              <Icon as={IoGameController} h='6' w='6' color={mode("black", "yellow")} mr='2' />
              <VStack spacing='2' alignItems='flex-start' lineHeight='1'>
                <Text as='b' pr='4'>
                  Game Freaks
                </Text>
                <Text fontSize='xx-small' mt='-1'>
                  v{packageJson.version}
                </Text>
              </VStack>
            </Box>
          </Button>
          <HStack as='nav' spacing='4' display={{ base: "none", md: "flex" }} flex='8'>
            <Tooltip label="Refresh page" placement="bottom">
            <IconButton
              icon={<RepeatIcon />}
              aria-label="Refresh page"
              size="xs"
              variant="ghost"
              colorScheme="gray"
              onClick={() => window.location.reload(true)}
            />
          </Tooltip>
            {Links.map((link) => (
              <NavLink
                route={link.route}
                key={link.route}
                onClick={closeMenu}
                state={link.route === "/jobs" || link.route === "/messages" ? { fromHeader: true } : undefined}
              >
                <Text fontWeight='medium'>{link.name}</Text>
              </NavLink>
            ))}
            {/* <ColorModeToggle flex='1' /> */}
            {/* Quick access to last viewed job */}
            {lastViewedJobNum && (
              <IconButton
                aria-label='Go to last job'
                icon={<TfiControlBackward />}
                colorScheme='teal'
                variant='outline'
                size='sm'
                //ml='2'
                onClick={() => {
                  //console.log("Current Path:", window.location.href);
                  if (!currentPath.includes(`/job/${lastViewedJobNum}`)) {
                    navigate(`/job/${lastViewedJobNum}`);
                  }
                }}
                title='Go to last viewed job'
              />
            )}
            {/* <InputGroup size='sm' ml='8' flex='2'> */}
            <Input
              variant='filled'
              placeholder='Go to Job No...'
              size='sm'
              w='120px'
              value={jobNoValue}
              onChange={(e) => setJobNoValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && jobNoValue.trim() !== "") {
                  window.location.href = `/job/${jobNoValue.trim()}`;
                }
              }}
            />
            {/* <InputRightAddon>
                <Button
                  size='xs'
                  maxH='20px'
                  onClick={() => {
                    if (jobNoValue.trim() !== "") {
                      window.location.href = `/job/${jobNoValue.trim()}`;
                    }
                  }}
                >
                  Go
                </Button>
              </InputRightAddon>
            </InputGroup> */}
          </HStack>
        </HStack>
        <Flex alignItems='center'>
          <Box mr='8'>
            {jobsInProgress && jobsInProgress.length > 0 && (
              <HStack spacing='4' alignItems='center' justifyContent='end'>
                <Text fontSize='sm' fontWeight='bold' color={gray700400}>
                  In Progress:
                </Text>
                <Badge colorScheme='green' fontSize='0.9em' px='2' py='1' borderRadius='md'>
                  {jobsInProgress.length}
                </Badge>
              </HStack>
            )}
            {jobsPaused && jobsPaused.length > 0 && (
              <HStack spacing='4' alignItems='center' justifyContent='end' mt='1'>
                <Text fontSize='sm' fontWeight='bold' color={gray700400}>
                  Paused:
                </Text>
                <Badge colorScheme='blue' fontSize='0.9em' px='2' py='1' borderRadius='md'>
                  {jobsPaused.length}
                </Badge>
              </HStack>
            )}
          </Box>
          <ColorModeToggle flex='1' />
          {userInfo ? (
            <Menu isLazy>
              <MenuButton ml='2' rounded='full' variant='link' cursor='pointer' minW='0'>
                <HStack>
                  <BiUserCheck size='30' />
                  <ChevronDownIcon />
                </HStack>
              </MenuButton>
              <Portal>
                <MenuList zIndex={2000}>
                  <HStack>
                    <Text pl='3' as='i'>
                      {userInfo.email}
                    </Text>
                  </HStack>
                  <Divider py='1' />

                  {/* <MenuItem as={ReactLink} to='/profile'>
                    Profile
                  </MenuItem> */}
                                    <MenuItem as={ReactLink} to='/tasks'>
                                      Tasks
                                    </MenuItem>
                                    <MenuItem as={ReactLink} to='/orders'>
                                      Orders
                                    </MenuItem>
                                    <MenuItem as={ReactLink} to='/job-log-search'>
                                      Job Log Search
                                    </MenuItem>
                  {userInfo.isAdmin && (
                    <>
                      <MenuDivider />
                      <MenuItem as={ReactLink} to='/setup'>
                        Setup
                      </MenuItem>
                      <MenuItem as={ReactLink} to='/logs'>
                        Activity Logs
                      </MenuItem>
                      <MenuGroup title='Statistics' bg={menuGroupBg} mt='2' pl='4' py='1' ml='0px' mr='0px'>
                        <MenuItem as={ReactLink} to='/revenue-stats'>
                          Revenue Statistics
                        </MenuItem>
                        <MenuItem as={ReactLink} to='/postcode-stats'>
                          Postcode Statistics
                        </MenuItem>
                      </MenuGroup>
                    </>
                  )}
                  <MenuDivider />
                  <MenuItem onClick={logoutHandler}>Logout</MenuItem>
                </MenuList>
              </Portal>
            </Menu>
          ) : (
            <Menu isLazy>
              <MenuButton as={IconButton} variant='ghost' cursor='pointer' icon={<BiLogInCircle size='25px' />} />
              <Portal>
                <MenuList zIndex={2000}>
                  <MenuItem as={ReactLink} to='/login' p='2' fontWeight='400' variant='link'>
                    Sign In
                  </MenuItem>
                  <MenuDivider />
                  <MenuItem as={ReactLink} to='/registration' p='2' fontWeight='400' variant='link'>
                    Signup
                  </MenuItem>
                </MenuList>
              </Portal>
            </Menu>
          )}
        </Flex>
      </Flex>
      <Box display='flex'>
        {isOpen && (
          <Box pb='4' display={{ md: "none" }}>
            <Stack as='nav' spacing='1' align='start'>
              {Links.map((link) => (
                <NavLink
                  route={link.route}
                  key={link.route}
                  onClick={closeMenu}
                  state={link.route === "/jobs" ? { fromHeader: true } : undefined}
                >
                  <Text fontWeight='medium'>{link.name}</Text>
                </NavLink>
              ))}
              <Button 
                  leftIcon={<RepeatIcon />}
                  aria-label='Refresh page'
                  size='sm'
                  variant='ghost'
                  py='1'
                  rounded='md'
                  onClick={() => window.location.reload(true)}
                >
                  <Text fontWeight='medium'>Refresh</Text>
                </Button>

            </Stack>

            {/* <ColorModeToggle /> */}
          </Box>
        )}
      </Box>
      {/* <Button onClick={onToggle}>Click Me</Button> */}
      <Slide direction='right' in={false} style={{ width: "40%", zIndex: 10, marginTop: "46px" }}>
        <Box p='40px' color='white' mt='4' bg='teal.500' rounded='md' shadow='md'>
          <Text fontSize='lg' align='center'>
            V1.0.1 - Search by date, Purple bookings on search results, 'Taken on' on Job screen
          </Text>
        </Box>
      </Slide>
    </Box>
  );
};

export default Header;
